/**
 * Theme Layout Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts and styles for all pages.
 *
 * @namespace theme
 * @file vendors@layout.theme.css.liquid
 * @file vendors@layout.theme.js
 * @file layout.theme.css.liquid
 * @file layout.theme.js
 *
 */
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes';
window.lazySizes.cfg.loadHidden = false;
import 'focus-visible';
import 'swiper/swiper-bundle.css';
import "../../styles/theme.scss";
import "../../styles/theme.css"; // Utilities

import "../utilities/base";
import "../utilities/currency";
import "../utilities/sections";
import "../utilities/theme-images";
import "../utilities/library-loader";
import "../utilities/utilities";
import "../utilities/layout";
import "../utilities/rte";
import "../utilities/local-storage-cookie";
import "../utilities/prevent-scroll-poly";
import "../utilities/queue-youtube"; // Components

import "../components/predictive-search";
import "../components/blog-filter";
import "../components/disclosures";
import "../components/zoom";
import "../components/product-model";
import "../components/product-form";
import "../components/tabs";
import "../components/collapse";
import "../components/a11y-dropdown";
import "../components/store-pickup";
import "../components/modals"; // Sections

import "../sections/header";
import "../sections/announcement-bar";
import "../sections/slideshow";
import "../sections/featured-product"; // Temporarily remove section
// import "../sections/mobile-navigation";

import "../sections/slider-cart";
import "../sections/email-modal";
import "../sections/password";
import "../sections/video";
import "../sections/footer";


    // If we reached this module (the entry point), it means no one accepted the HRM.
    // Let's reload the page then.
    if (module.hot) {
      module.hot.accept();
      // On first load, module.hot.data is undefined since it is not an update...
      // So if we do have a data object, it means we've been HMR'ed.
      if (module.hot.data) {
        window.__shopify_pipeline_should_reload__ = true;
      }
    }
  